/*=========================================================================================
File Name: sidebarItems.js
Description: Sidebar Items list. Add / Remove menu items from here.
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default [
  {
    url: `/partner/current-cycle/${localStorage.getItem('loggedInPartnerName')}`,
    name: "Current Cycle",
    icon: "InfoIcon",
    slug: "current-cycle",
    i18n: "current-cycle",
  },
  // {
  //   url: `/partner/past-payments/${localStorage.getItem('loggedInPartnerName')}`,
  //   name: "Past Payments",
  //   icon: "CreditCardIcon",
  //   slug: "past-payments",
  //   i18n: "past-payments",
  // },
  // {
  //   url: `/partner/agreements/${localStorage.getItem('loggedInPartnerName')}`,
  //   icon: "FileTextIcon",
  //   name: "Agreements",
  //   slug: "agreements",
  //   i18n: "agreements",
  // },
];
